<template>
    <div class="cloud-animation-container">
        <div
            v-for="(cloud, index) in clouds"
            :key="`cloud-${index}`"
            class="cloud"
            :style="{
                top: cloud.top + '%',
                animationDelay: cloud.delay + 's',
                animationDuration: cloud.duration + 's',
            }"
        >
            <div class="cloud-body"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CloudAnimation",
    data() {
        return {
            clouds: [],
        };
    },
    mounted() {
        this.generateClouds();
    },
    methods: {
        generateClouds() {
            this.clouds = [];
            for (let i = 0; i < 5; i++) {
                this.clouds.push({
                    top: 20 + Math.random() * 60, // 20% ~ 80% 높이
                    delay: Math.random() * 3,
                    duration: 4 + Math.random() * 2,
                });
            }
        },
    },
};
</script>

<style scoped>
.cloud-animation-container {
    position: absolute;
    top: 0;
    left: 0%;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
}

.cloud {
    position: absolute;
    left: -50px;
    animation: cloudMove linear infinite;
}

.cloud-body {
    width: 15px;
    height: 10px;
    background: linear-gradient(135deg, #e0e0e0, #bdbdbd);
    border-radius: 10px;
    position: relative;
    opacity: 0.8;
}

.cloud-body::before {
    content: "";
    position: absolute;
    top: -4px;
    left: 2px;
    width: 10px;
    height: 8px;
    background: linear-gradient(135deg, #e0e0e0, #bdbdbd);
    border-radius: 8px;
}

.cloud-body::after {
    content: "";
    position: absolute;
    top: -2px;
    right: 2px;
    width: 8px;
    height: 6px;
    background: linear-gradient(135deg, #e0e0e0, #bdbdbd);
    border-radius: 6px;
}

@keyframes cloudMove {
    0% {
        transform: translateX(-50px) scale(0.8);
        opacity: 0;
    }
    10% {
        opacity: 0.8;
    }
    85% {
        opacity: 0.8;
    }
    100% {
        transform: translateX(calc(400% + 50px)) scale(1.2);
        opacity: 0;
    }
}
</style>
